import "./i18n.js";


import "./ew-block-pro/ew-archive";
/* import "./ew-block/ew-author";
import "./ew-block/ew-category";
import "./ew-block/ew-page";
import "./ew-block/ew-post";
import "./ew-block/ew-tags";
import "./ew-block/ew-menu"; */
// import "./catch-slider-pro-block";
/* import "./food-menu";
import "./testimonial";
import "./portfolio";
import "./team";
import "./event";
import "./service"; */